import {TabData} from "../types/competitor-article-sync.types";
import {BaseFormField} from "../../../../../../../core/types/form-field.types";

export const tabsData: Array<TabData> = [
  {
    title: 'Синхронизированные',
    key: 'sync',
    btnKey: 'detach',
    emptyText: 'Синхронизированных карт продукта пока нет'
  },
  {
    title: 'К синхронизации',
    key: 'all',
    btnKey: 'attach',
    emptyText: 'Нет доступных карт продукта для синхронизации'
  }
]

export const competitorArticleParamsData: Array<BaseFormField> = [
  {
    fieldName: 'url',
    label: 'URL на страницу товара'
  },
  {
    fieldName: 'article',
    label: 'Артикул'
  },
  {
    fieldName: 'productTitle',
    label: 'Заголовок продукта на маркетплейсе'
  },
  {
    fieldName: 'articleName',
    label: 'Пользовательское название артикула'
  },
  {
    fieldName: 'productGroupId',
    label: 'id категории продуктов'
  },
  {
    fieldName: 'rating',
    label: 'Рейтинг товара',
  },
  {
    fieldName: 'reviewsCount',
    label: 'Количество отзывов'
  }
]
